import cognitoAuth from "@/cognito";

export default (to, from, next) => {
  next();
};
